"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validUsageContext = exports.CarrierLookup = void 0;
const stringEnum_1 = require("./stringEnum");
exports.CarrierLookup = (0, stringEnum_1.stringEnum)([
    "australia_post",
    "aramex",
    "asendia_us",
    "axlehire",
    "bettertrucks",
    "borderguru",
    "boxberry",
    "bring",
    "canada_post",
    "correios_br",
    "correos_espana",
    "collect_plus",
    "couriersplease",
    "deutsche_post",
    "dhl_benelux",
    "dhl_germany",
    "dhl_ecommerce",
    "dhl_express",
    "dpd_germany",
    "dpd_uk",
    "doordash",
    "estafeta",
    "fastway_australia",
    "fedex",
    "gls_de",
    "gls_fr",
    "globegistics",
    "gophr",
    "gls",
    "hermes_uk",
    "hongkong_post",
    "lasership",
    "lso",
    "mondial_relay",
    "new_zealand_post",
    "newgistics",
    "nippon_express",
    "ontrac",
    "orangeds",
    "parcel",
    "pcf",
    "posti",
    "purolator",
    "rr_donnelley",
    "russian_post",
    "sendle",
    "skypostal",
    "stuart",
    "tforce",
    "uds",
    "ups",
    "usps",
    "yodel",
    "cdl",
    "freight",
    "courier",
]);
exports.validUsageContext = (0, stringEnum_1.stringEnum)(["PARCEL", "ZONE_SKIPPING"]);
//# sourceMappingURL=CarrierAccount.js.map